import { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, useState } from 'react';
import { Icon } from './Icon';

export const SectionTitle = ({ children, action }: { children: ReactNode; action?: ReactNode }) => (
  <div className="section-title">
    <h2>{children}</h2>
    {action}
  </div>
);

/**
 * Раскрывающаяся секция («раскрывающееся меню»). На десктопе раскрыта по умолчанию,
 * на мобильных — свёрнута, чтобы панель не растягивалась на весь экран.
 */
export const Accordion = ({
  title,
  count,
  defaultOpen,
  children,
}: {
  title: ReactNode;
  count?: number;
  defaultOpen?: boolean;
  children: ReactNode;
}) => {
  const [open, setOpen] = useState(defaultOpen ?? (typeof window === 'undefined' ? true : window.innerWidth > 640));
  return (
    <section className={`accordion${open ? ' open' : ''}`}>
      <button
        type="button"
        className="accordion-head"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="accordion-title">
          {title}
          {count != null && <i className="title-count">{count}</i>}
        </span>
        <Icon name="chevron" />
      </button>
      <div className={`accordion-body${open ? ' open' : ''}`}>{children}</div>
    </section>
  );
};

export const Field = ({
  label,
  suffix,
  ...props
}: { label: string; suffix?: string } & InputHTMLAttributes<HTMLInputElement>) => (
  <label className="field">
    <span>{label}</span>
    <span className="input-shell">
      <input {...props} />
      {suffix && <small>{suffix}</small>}
    </span>
  </label>
);

export const SelectField = ({
  label,
  children,
  ...props
}: { label: string; children: ReactNode } & SelectHTMLAttributes<HTMLSelectElement>) => (
  <label className="field">
    <span>{label}</span>
    <span className="input-shell select-shell">
      <select {...props}>{children}</select>
    </span>
  </label>
);

export const Toggle = ({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <label className="toggle-row">
    <span>{label}</span>
    <input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} />
    <span className="toggle" aria-hidden="true" />
  </label>
);
